import React from "react";

const AutoLinkText = ({ text }) => {
  // Regular expression to match URLs with or without protocol (http://, https://, www)
  const urlRegex =
    /((https?:\/\/)|(www\.))?([a-zA-Z0-9\-\.]+)(\.[a-zA-Z]{2,})(\/[^\s]*)?/g;

  // Replace URLs with <a> tags
  const linkedText = text.replace(
    urlRegex,
    (match, p1, p2, domain, tld, path) => {
      const fullUrl = p1 ? p1 + match : "http://" + match; // Prepend http:// if no protocol is provided
      return `<a href="${fullUrl}" onclick="event.stopPropagation()" target="_blank" rel="noopener noreferrer">${match}</a>`;
    }
  );

  return (
    <div
      style={{ whiteSpace: "pre-wrap" }}
      dangerouslySetInnerHTML={{ __html: linkedText }}
    />
  );
};

export default AutoLinkText;
